/**
 * Created by Jerker Nord on 2018-06-27.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";

export class IceIceYetiMSymbolSpinStopController extends ReelStopPresentationController {

    private _yetiData:IceIceYetiParsedGameData;

    constructor(index:number) {
        super(index, "IceIceYetiMSymbolSpinStopController");
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        this._yetiData = data;
    }

    //Animate M symbols on reel stop
    public onReelBounce(data:IReelStoppedData):void {
        let tempSym:StateReelSymbol;
        for(let i:number = 6; i > -1; i--) {
            tempSym = Reels.getSymbol(data.reelId, i)!;
            if(tempSym && tempSym.symName.indexOf("M") == 0 && !this._yetiData.overlaySymbolsBeforeSpin[data.reelId][i]) {
                tempSym.changeState({state : IceIceYetiGameConfig.instance.SYMBOL_STATES.land});
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}